import React from "react";
import {
  Block as Blockicon,
  Edit as EditIcon,
  FlipToFront,
  Refresh as RefreshIcon,
  VisibilityOff as VisibilityoffIcon,
  Visibility as VisibilityIcon,
  Check as CheckIcon,
  SaveAlt as SaveAltIcon,
  Send as SendIcon,
  CreditCard,
  AccountBalance,
  PanTool,
  Visibility,
  ThumbUp,
  AddBox,
  Replay,
} from "@material-ui/icons";

import DeleteIcon from "@material-ui/icons/Delete";
import RedeemIcon from "@material-ui/icons/Redeem";
import { hasPermission } from "../services/hasPermission";

export const usersMenu = [
  {
    icon: <EditIcon />,
    title: "Edit User",
    key: "editUser",
  },
  {
    icon: <RefreshIcon />,
    title: "Reset Password",
    key: "resetPassword",
    disabled: hasPermission(["RESET PASSWORD"]),
  },
  {
    icon: <Blockicon />,
    title: "Deactivate User",
    key: "deactivateUser",
    disabled: hasPermission(["DEACTIVATE USER"]),
  },
  {
    icon: <CheckIcon />,
    title: "Activate User",
    key: "activateUser",
    disabled: hasPermission(["ACTIVATE USER"]),
  },
];
export const usersNonAdminMenu = [
  {
    icon: <RefreshIcon />,
    title: "Reset Password",
    key: "resetPassword",
    disabled: hasPermission(["RESET PASSWORD"]),
  },
  {
    icon: <Blockicon />,
    title: "Deactivate User",
    key: "deactivateUser",
    disabled: hasPermission(["DEACTIVATE USER"]),
  },
  {
    icon: <CheckIcon />,
    title: "Activate User",
    key: "activateUser",
    disabled: hasPermission(["ACTIVATE USER"]),
  },
];

export const csrPolicyMenu = [
  {
    icon: <Visibility />,
    title: "View Policy",
    key: "viewPolicy",
  },
  // {
  //   icon: <EditIcon />,
  //   title: "Endorse Policy",
  //   key: "amendPolicy",
  // },
];

export const approvePolicyMenu = [
  {
    icon: <Visibility />,
    title: "View Policy",
    key: "viewPolicy",
  },
  {
    icon: <ThumbUp />,
    title: "Approve",
    key: "approvePolicy",
  },
  {
    icon: <AddBox />,
    title: "Generate Three Options Letter",
    key: "generateLetter",
  },
];
export const approveEndorsementMenu = [
  {
    icon: <ThumbUp />,
    title: "Approve",
    key: "approveEndorsementPolicy",
  },
  {
    icon: <Visibility />,
    title: "View Policy",
    key: "viewPolicy",
  },
];
export const approvePipBillsMenu = [
  {
    icon: <ThumbUp />,
    title: "Approve",
    key: "approvePipBill",
  },
  {
    icon: <FlipToFront />,
    title: "Print EOB",
    key: "eob",
  },
 
  
];
export const NoteListMenus = [
  {
    icon: <Visibility />,
    title: "View Notes",
    key: "viewNotes",
  },
  {
    icon: <DeleteIcon />,
    title: "Delete Notes",
    key: "deleteNotes",
    disabled: hasPermission(["DELETE POLICY NOTES"]),
  },
];
export const paymentsListMenu = [
  {
    icon: <CreditCard />,
    title: "Void",
    key: "void",
    disabled: hasPermission(["VOID UW PAYMENTS"]),
  },

  {
    icon: <AccountBalance />,
    title: "NSF",
    key: "nsf",
    disabled: hasPermission(["NSF"]),
  },
  {
    icon: <PanTool />,
    title: "Stop Payment",
    key: "stop",
    disabled: hasPermission(["STOP PAYMENT"]),
  },
  {
    icon: <Replay />,
    title: "Reverse EFT/ACH",
    key: "reverse",
    disabled: hasPermission(["REVERSE ACH/EFT"]),
  },
  {
    icon: <RedeemIcon />,
    title: "Refund Card Connect Payment",
    key: "cardConnect",
  },
];

export const nsfRemovalMenu = [
  {
    icon: <DeleteIcon />,
    title: "NSF Removal",
    key: "nsf",
    disabled: false,
  },
];

export const diaryMenuList = [
  {
    icon: <RefreshIcon />,
    title: "Clear Diary",
    key: "clearPolicy",
    // disabled: false
  },
];

export const workFlowMenuList = [
  {
    icon: <VisibilityIcon />,
    title: "View IMAGE",
    key: "viewImage",
  },
  {
    icon: <FlipToFront />,
    title: "COMPLETE",
    key: "complete",
  },
  // {
  //   icon: <EditIcon />,
  //   title: "RE-CLASSIFY",
  //   key: "reClassify",
  // },
];
export const dirverMenuList = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editDriver",
  },
  {
    icon: <VisibilityIcon />,
    title: "View",
    key: "viewDriver",
  },
];
export const dirverMenuListEndorse = [
  {
    icon: <VisibilityIcon />,
    title: "View",
    key: "viewDriver",
  },
];

export const vehiclesMenuList = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editVehicle",
  },
  {
    icon: <VisibilityIcon />,
    title: "View",
    key: "viewCar",
  },
];
export const vehiclesMenuListEndorse = [
  {
    icon: <VisibilityIcon />,
    title: "View",
    key: "viewCar",
  },
];

export const documentListMenu = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editDescription",
  },
  {
    icon: <SendIcon />,
    title: "Send File",
    key: "sendFile",
  },
  {
    icon: <SaveAltIcon />,
    title: "Save To",
    key: "saveTo",
  },
  {
    icon: <VisibilityoffIcon />,
    title: "Hide Image",
    key: "hideImage",
    disabled: hasPermission(["ALLOW UND HIDE IMAGING"]),
  },
  {
    icon: <VisibilityIcon />,
    title: "Show Hidden",
    key: "showHidden",
  },
];

export const documentListMenuHide = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editDescription",
  },
  {
    icon: <SendIcon />,
    title: "Send File",
    key: "sendFile",
  },
  {
    icon: <SaveAltIcon />,
    title: "Save To",
    key: "saveTo",
  },
  {
    icon: <VisibilityoffIcon />,
    title: "Hide Image",
    key: "hideImage",
    disabled: hasPermission(["ALLOW UND HIDE IMAGING"]),
  },
];
export const historyMenu = [
  {
    icon: <VisibilityoffIcon />,
    title: "Hide History",
    key: "hideHistory",
    disabled: hasPermission(["HIDE HISTORY"]),
  },
  {
    icon: <VisibilityIcon />,
    title: "Show History",
    key: "showHistory",
    disabled: hasPermission(["UNHIDE HISTORY"]),
  },
];
export const historyMenuOne = [
  {
    icon: <VisibilityoffIcon />,
    title: "Hide History",
    key: "hideHistory",
    disabled: hasPermission(["HIDE HISTORY"]),
  },
];

export const showhistoryMenuOne = [
  {
    icon: <VisibilityIcon />,
    title: "Show History",
    key: "showHistory",
    disabled: hasPermission(["UNHIDE HISTORY"]),
  },
];
export const csrClaimsMenu = [
  {
    icon: <Visibility />,
    title: "View",
    key: "viewClaims",
  },
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editClaims",
    disabled: hasPermission(["EDIT CLAIM"]),
  },
];
export const claimsPaymentMenuList = [
  {
    icon: <Visibility />,
    title: "Void",
    key: "void",
  },
  {
    icon: <EditIcon />,
    title: "Print",
    key: "print",
  },
  {
    icon: <EditIcon />,
    title: "Change Payment Type",
    key: "changePT",
  },
];
export const csrProvidersMenu = [
  {
    icon: <Visibility />,
    title: "View",
    key: "viewProvider",
  },
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editProvider",
    disabled: hasPermission(["EDIT PROVIDERS"]),
  },
];

export const csrCptCodeMenu = [
  {
    icon: <Visibility />,
    title: "View",
    key: "viewCptCode",
  },
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editCptCode",
  },
];
export const csrAgentsMenu = [
  {
    icon: <Visibility />,
    title: "View",
    key: "viewAgents",
  },
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editAgents",
  },
];

export const firstReportClaimsMenu = [
  {
    icon: <Visibility />,
    title: "View",
    key: "viewFr",
  },
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "editFr",
    disabled: hasPermission(["EDIT 1ST REPORT"]),
  },
  {
    icon: <FlipToFront />,
    title: "Convert to Claim",
    key: "moveFr",
    disabled: hasPermission(["NEW CLAIM"]),
  },
];

export const ClaimsPaymentsMenu = [
  {
    icon: <Visibility />,
    title: "View Claims",
    key: "viewClaims",
  },
  {
    icon: <Visibility />,
    title: "View EOB",
    key: "viewEob",
  },
  {
    icon: <Visibility />,
    title: "View HCFA",
    key: "viewHcfa",
  },
];

export const moneyBatchMenu = [
  {
    icon: <CreditCard />,
    title: "Edit Payment",
    key: "EDIT",
  },
];

export const departmentMenuList = [
  {
    icon: <EditIcon />,
    title: "Edit Complaints",
    key: "EDIT",
  },
];

export const agentLoginMenuList = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "EDIT",
  },
  {
    icon: <></>,
    title: "Toggle Active",
    key: "Toggle",
  },
];

export const agentLoginInactive = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "EDIT",
  },
  {
    icon: <></>,
    title: "Toggle Inactive",
    key: "Toggle",
  },
];
export const agentAppointmentMenuList = [
  {
    icon: <EditIcon />,
    title: "Edit",
    key: "EDIT",
  },
];

export const agentCommPaymentMenuList = [
  {
    icon: <></>,
    title: "Void",
    key: "Void",
  },
];

export const agentNoteMenuList = [
  {
    icon: <></>,
    title: "delete",
    key: "delete",
  },
];
